import React from 'react'

export const formatAccordionText = (text: string, colorPrimary: string) => {
  return text.split(' ').map((word, index, array) => {
    const cleanWord = word.replace(/[^\w\s]|_/g, '').toLowerCase()
    if (cleanWord === 'physiciangps') {
      const [physicianGPS, punctuation] = word.split(/([\?\!\.])/)
      return (
        <React.Fragment key={index}>
          <span
            aria-labelledby={`physician-gps-text-${index}`}
            style={{
              fontStyle: 'italic',
              fontWeight: 700,
              color: colorPrimary,
            }}
          >
            {physicianGPS}
          </span>
          {punctuation}
          {index < array.length - 1 && ' '}
        </React.Fragment>
      )
    }
    return (
      <React.Fragment key={index}>
        {word}
        {index < array.length - 1 && ' '}
      </React.Fragment>
    )
  })
}
